// src/components/LatestCollection.jsx
import React, { useContext } from 'react';
import {
  Box,
  Container,
  Typography,
} from '@mui/material';
import { ShopContext } from '../context/ShopContext';
import ProductItem from './ProductItem';

const LatestCollection = () => {
    const { products } = useContext(ShopContext);

  // Get the first 8 products for the collection
  const latestProducts = Array.isArray(products) ? products.slice(0, 8) : [];

  return (
    <Box sx={{ py: 8, backgroundColor: 'background.default' }}>
      <Container maxWidth="lg">
        {/* Section Title */}
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Typography variant="h4" component="h2" fontWeight="bold" gutterBottom>
            Latest Collection
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            Explore our newest arrivals and find your next favorite piece.
          </Typography>
        </Box>

        {/* Products Grid */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: 'repeat(auto-fill, minmax(200px, 1fr))',
              sm: 'repeat(auto-fill, minmax(220px, 1fr))',
              md: 'repeat(3, 1fr)',
              lg: 'repeat(4, 1fr)',
            },
            gap: 3,
          }}
        >
          {latestProducts.map((product) => (
            <ProductItem key={product.id} product={product} />
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default LatestCollection;

